import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Alert,
    Autocomplete,
    Grid,
    Tabs,
    FormControl,
    FormControlLabel,
    Checkbox,
    Typography,
    TextField,
    FormGroup,
    Select,
    MenuItem,
    FormHelperText,
    Box,
} from '@mui/material'
import { LoadingDefault } from '@/shared/ui/loading'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons/faExclamationCircle'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { faAngleDown } from '@fortawesome/pro-duotone-svg-icons/faAngleDown'

import DisplayItemSettings from './DisplayItemSettings/DisplayItemSettings'
import LocaleName from '@/shared/composed-ui/locale-name/LocaleName'
import ObjectCreatedInfo from '@/shared/composed-ui/object-created-info/ObjectCreatedInfo'
import SelectList from '@/feature/admin/Templates/select/SelectList'
import { Editor } from '@tinymce/tinymce-react'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { StyledButton } from '@/shared/ui/buttons'
import { StyledVerticalTab } from '@/shared/ui/tabs'
import { TabPanel } from '@/shared/ui/tab-panel'
import { brandedTokens } from '@/theme/tokens'
import { FormInputLabel } from '@/shared/ui/input'
import { autocompleteGroupedSlotProps } from '@/shared/ui/styles'

class DisplayItemForm extends Component {
    constructor(props) {
        super(props)

        //TODO: Change this
        if (this.props.item && this.props.item.def_dossier_def_field) {
            this.props.item.defDossierDefField =
                this.props.item.def_dossier_def_field
        }
        //TODO: change this
        if (this.props.item && this.props.item.def_dossier_link) {
            this.props.item.defDossierLink = this.props.item.def_dossier_link
        }

        this.state = {
            loading: false,
            fetchingPositions: false,
            fetchingLinks: false,
            fetchingFields: false,
            defDossier: this.props.defDossier,
            submitting: false,
            errors: false,
            dataFields: [],
            linkFields: [],
            displayPositions: [],
            baseFields: [],
            availableRoles: [],
            item: this.props.item
                ? this.props.item
                : {
                      col: 1,
                      rank: 1,
                      roles: [],
                      translations: [],
                  },
            activeTab: 'labels',
        }

        this.handleErrors = this.handleErrors.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onChangeTranslation = this.onChangeTranslation.bind(this)
        this.onChangeRole = this.onChangeRole.bind(this)
        this.onChangeTranslationSettings =
            this.onChangeTranslationSettings.bind(this)
        this.onChangeObjectField = this.onChangeObjectField.bind(this)
        this.submitDisplayItem = this.submitDisplayItem.bind(this)
        this.onChangeSettings = this.onChangeSettings.bind(this)
    }

    /**
     * @param response
     * @returns {boolean}
     */
    hasFormErrors(response) {
        if (
            response.response.status === 400 &&
            response.response.data &&
            response.response.data.errors
        ) {
            return true
        }

        return false
    }

    handleSuccess(newItem) {
        setTimeout(
            () =>
                this.setState({
                    submitting: false,
                    item: {},
                    errors: false,
                }),
            300
        )

        this.props.onClose(true, newItem)
        if (this.props.onSuccess) {
            this.props.onSuccess()
        }
    }

    handleErrors(response) {
        if (!this.hasFormErrors(response)) {
            this.setState({
                submitting: false,
                errors: { generic: this.props.kedo.t('Something went wrong') },
            })
            return
        }
        this.setState({
            submitting: false,
            errors: response.response.data.errors,
        })
    }

    handleChange(event) {
        let item = this.state.item
        item[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    submitDisplayItem() {
        this.setState({
            submitting: true,
            errors: false,
        })

        let errors = {}
        let hasErrors = false
        let item = {
            col: this.state.item.col,
            rank: this.state.item.rank,
            rowspan: 0,
            colspan: this.state.item.colspan,
            view: this.state.item.view,
            defaultPermissionType: '',
            roles:
                this.state.item && this.state.item.roles
                    ? this.state.item.roles
                    : [],
            translations: this.state.item.translations,
        }

        item.permissions_type = this.state.item.permissions_type

        if (this.state.item.settings) {
            item.settings = this.state.item.settings
        }

        if (this.props.item && this.props.item.id) {
            item.id = this.props.item.id
        } else if (this.props.id) {
            item.id = this.props.id
        }

        if (this.state.item.display_position) {
            item.displayPosition = this.state.item.display_position.id
        }

        if (this.state.item.defDossierDefField) {
            item.defDossierDefField = this.state.item.defDossierDefField.id
        } else if (this.state.item.defDossierLink) {
            item.defDossierLink = this.state.item.defDossierLink.id
        } else if (
            !this.state.item.defDossierLink &&
            !this.state.item.defDossierDefField &&
            this.state.item.settings.block
        ) {
            //Chart settings
        } else if (
            !this.state.item.defDossierLink &&
            !this.state.item.defDossierDefField &&
            this.state.item.settings &&
            this.state.item.settings.dossier_data
        ) {
            //Dossier data field
        } else {
            hasErrors = true
            errors.defDossierDefField = this.props.kedo.t(
                'Choose a data field or a link field'
            )
            errors.defDossierLink = this.props.kedo.t(
                'Choose a data field or a link field'
            )
        }

        if (!item.view || item.view.length <= 0) {
            errors.view = this.props.kedo.t('This is a required field')
            hasErrors = true
        }

        if (hasErrors) {
            this.setState({
                submitting: false,
                errors: errors,
            })
            return
        }

        if (item.id) {
            this.props.kedo
                .api()
                .patch(
                    this.props.kedo.api().getDisplayItemEndpoint() +
                        '/' +
                        item.id,
                    item
                )
                .then((successResponse) => this.handleSuccess(item))
                .catch((errResponse) => this.handleErrors(errResponse))
        } else {
            item.environment = this.props.kedo.env().getEnvironment().id
            item.defDossier = parseInt(this.state.defDossier)
            item.uuid = this.props.kedo.utils().uuidv4()

            this.props.kedo
                .api()
                .post(this.props.kedo.api().getDisplayItemEndpoint(), item)
                .then((successResponse) => {
                    item.id = successResponse.data.id
                    this.handleSuccess(item)
                })
                .catch((errResponse) => this.handleErrors(errResponse))
        }
    }

    renderErrorFeedback(errorMsg) {
        if (!errorMsg) {
            return
        }

        return <FormHelperText>{errorMsg}</FormHelperText>
    }

    onChangeTranslationSettings(locale, text, textKey) {
        let ddiItem = this.state.item

        if (!ddiItem.translations || ddiItem.translations.length <= 0) {
            ddiItem.translations = []
        }

        let trans = ddiItem.translations.find((item) => item.culture === locale)
        let translations = ddiItem.translations.filter(
            (item) => item.culture !== locale
        )

        ddiItem.translations = translations
        if (!trans) {
            trans = { culture: locale, name: '', settings: {} }
        } else {
            if (!trans.settings) {
                trans.settings = {}
            } else if (Array.isArray(trans.settings)) {
                trans.settings = {}
            }
        }

        if (textKey === 'informationtext') {
            trans.settings.informationtext = text
        } else if (textKey === 'pretext') {
            trans.settings.pretext = text
        }

        translations.push(trans)
        ddiItem.translations = translations
        this.setState({ item: ddiItem })
    }

    onChangeTranslation(locale, ddiName) {
        let ddiItem = this.state.item

        if (!ddiItem.translations || ddiItem.translations.length <= 0) {
            ddiItem.translations = []
        }

        let trans = ddiItem.translations.find((item) => item.culture === locale)
        let translations = ddiItem.translations.filter(
            (item) => item.culture !== locale
        )

        ddiItem.translations = translations
        if (!trans) {
            trans = { culture: locale, name: ddiName }
        } else {
            trans.name = ddiName
        }
        translations.push(trans)
        ddiItem.translations = translations

        this.setState({ item: ddiItem })
    }

    fetchFields() {
        let url =
            this.props.kedo.api().getDefDossierDefFieldEndpoint() +
            '?limit=500&defDossier=' +
            this.props.defDossier
        this.setState({ fetchingFields: true })
        this.props.kedo
            .api()
            .getCached(url)
            .then((response) =>
                this.setState({
                    dataFields: response.data.results,
                    fetchingFields: false,
                })
            )
    }

    fetchLinks() {
        let url =
            this.props.kedo.api().getDefDossierLinkEndpoint() +
            '?limit=500&defDossier=' +
            this.props.defDossier
        this.setState({ fetchingLinks: true })
        this.props.kedo
            .api()
            .get(url)
            .then((response) =>
                this.setState({
                    linkFields: response.data.results,
                    fetchingLinks: false,
                })
            )
    }

    fetchDisplayPositions() {
        let url =
            this.props.kedo.api().getDisplayPositionEndpoint() +
            '?limit=500&defDossier=' +
            this.props.defDossier
        this.setState({ fetchingPositions: true })
        this.props.kedo
            .api()
            .getCached(url)
            .then((response) =>
                this.setState({
                    displayPositions: response.data.results,
                    fetchingPositions: false,
                })
            )
    }

    fetchBaseFields() {
        let params = {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 500,
            },
        }
        this.setState({ loadingBaseFields: true })
        this.props.kedo
            .api()
            .getCached(this.props.kedo.api().getDefFieldEndpoint(), params)
            .then((response) =>
                this.setState({
                    baseFields: response.data.results,
                    loadingBaseFields: false,
                })
            )
    }

    fetchRoles() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.get(api.getRoleEndpoint(), {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 200,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                availableRoles: response.data.results,
            })
        )
    }

    fetchExistingItem() {
        const kedo = this.props.kedo
        const api = kedo.api()
        this.setState({ loading: true })
        api.getCached(api.getDisplayItemEndpoint(this.props.id)).then(
            (response) => {
                let ddi = response.data

                if (ddi && ddi.def_dossier_def_field) {
                    ddi.defDossierDefField = ddi.def_dossier_def_field
                }
                if (ddi && ddi.def_dossier_link) {
                    ddi.defDossierLink = ddi.def_dossier_link
                }
                ddi.roles = ddi.roles.map((ddiRole) => ddiRole.role.id)

                this.setState({
                    loading: false,
                    item: ddi,
                })
            }
        )
    }

    componentDidMount() {
        if (this.props.id) {
            this.fetchExistingItem()
        }

        this.fetchFields()
        if (!this.props.item || this.props.item.defDossierLink) {
            this.fetchLinks()
        }
        if (!this.props.item || this.props.item.defDossierDefField) {
            this.fetchBaseFields()
        }
        this.fetchDisplayPositions()
        this.fetchRoles()
    }

    isDataField() {
        return (
            (this.props.item && this.props.item.defDossierDefField) ||
            (this.state.item && this.state.item.defDossierDefField)
        )
    }

    isLinkField() {
        return (
            (this.props.item && this.props.item.defDossierLink) ||
            (this.state.item && this.state.item.defDossierLink)
        )
    }

    renderTranslations(translations) {
        if (!translations || translations.length <= 0) {
            translations = []
        }
        let locales = this.props.kedo.env().getEnvironmentLocales()

        if (!locales) {
            return this.props.kedo.t('No languages set')
        }

        const isLocked = this.state.item?.locked === true

        return (
            <div className="language_accordion">
                {locales.map((locale) => {
                    let trans = translations.find(
                        (item) => locale.code === item.culture
                    )
                    if (!trans) {
                        trans = {}
                    }
                    return (
                        <Accordion
                            key={locale.id}
                            defaultExpanded={locales[0].id === locale.id}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <FontAwesomeIcon icon={faAngleDown} />
                                }
                                aria-controls={`panel-${locale.id}-content`}
                                id={`panel-${locale.id}-header`}
                                sx={{
                                    backgroundColor:
                                        brandedTokens.variables
                                            .secondaryScale[10],
                                }}
                            >
                                <Typography>
                                    <LocaleName
                                        kedo={this.props.kedo}
                                        localeCode={locale.code}
                                    />
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <FormInputLabel>
                                        {this.props.kedo.t('Name')}
                                    </FormInputLabel>

                                    <TextField
                                        value={trans.name}
                                        type="text"
                                        onChange={(event) =>
                                            this.onChangeTranslation(
                                                locale.code,
                                                event.target.value
                                            )
                                        }
                                        error={!!this.state.errors[locale]}
                                        size="small"
                                        disabled={isLocked}
                                    />
                                </FormControl>
                                <FormControl
                                    component="fieldset"
                                    sx={{ mt: 2 }}
                                >
                                    <FormInputLabel>
                                        {this.props.kedo.t('Information text')}
                                    </FormInputLabel>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    this.state.item?.settings
                                                        ?.show_info_direct ??
                                                    false
                                                }
                                                onChange={(e) =>
                                                    this.onChangeSettings(
                                                        'show_info_direct',
                                                        e.target.checked
                                                    )
                                                }
                                                name="show_info_direct"
                                                id="radio-show-overlay"
                                                size="small"
                                            />
                                        }
                                        label={this.props.kedo.t(
                                            'Show info direct'
                                        )}
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontWeight: 500,
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                        disabled={isLocked}
                                    />
                                    <Box sx={{ position: 'relative' }}>
                                        <Editor
                                            value={
                                                trans.settings &&
                                                trans.settings.informationtext
                                                    ? trans.settings
                                                          .informationtext
                                                    : null
                                            }
                                            onEditorChange={(content) =>
                                                this.onChangeTranslationSettings(
                                                    locale.code,
                                                    content,
                                                    'informationtext'
                                                )
                                            }
                                            init={{
                                                readonly: isLocked,
                                                editable: !isLocked,
                                                branding: false,
                                                default_link_target: '_blank',
                                                relative_urls: false,
                                                remove_script_host: true,
                                                convert_urls: true,
                                                font_formats:
                                                    'Arial=arial,helvetica,sans-serif; Arial Black=arial black,gadget,sans-serif; Comic Sans=comic sans ms,cursive,sans-serif; Courier New=courier new,courier,monospace; Georgia=georgia,serif; Impact=impact,charcoal,sans-serif; Lucida Sans Unicode=lucida sans unicode,lucida grande,sans-serif; Palatino Linotype=alatino linotype,book antiqua,palatino,serif; Tahoma=tahoma,geneva,sans-serif; Trebuchet=trebuchet,helvetica,sans-serif; Times New Roman =times new roman,times,serif; Verdana=verdana,geneva,sans-serif;',
                                                fontsize_formats:
                                                    '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
                                                height: 250,
                                                body_class: 'tinyMCE-editor',
                                                browser_spellcheck: true,
                                                contextmenu: false,
                                                plugins: [
                                                    'table',
                                                    'lists',
                                                    'link',
                                                    'autolink',
                                                    'emoticons',
                                                    'help',
                                                ],
                                                menubar: false,
                                                toolbar:
                                                    'undo redo | styleselect | fontselect fontsizeselect bold italic underline strikethrough forecolor backcolor | hr link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | table | emoticons | removeformat  | paste | help',
                                                toolbar_mode: 'sliding',
                                                paste_data_images: true,
                                                setup: (editor) => {
                                                    let parentDialog = null

                                                    editor.on(
                                                        'ExecCommand',
                                                        (e) => {
                                                            if (
                                                                e.command ===
                                                                'mceLink'
                                                            ) {
                                                                parentDialog =
                                                                    document.querySelector(
                                                                        'div[role="dialog"][aria-modal="true"]'
                                                                    )

                                                                if (
                                                                    parentDialog
                                                                ) {
                                                                    parentDialog.setAttribute(
                                                                        'aria-modal',
                                                                        'false'
                                                                    )
                                                                    parentDialog.setAttribute(
                                                                        'inert',
                                                                        ''
                                                                    )
                                                                    parentDialog.style.pointerEvents =
                                                                        'none'
                                                                    parentDialog.style.userSelect =
                                                                        'none'
                                                                }
                                                            }
                                                        }
                                                    )

                                                    editor.on(
                                                        'CloseWindow',
                                                        (e) => {
                                                            if (parentDialog) {
                                                                parentDialog.setAttribute(
                                                                    'aria-modal',
                                                                    'true'
                                                                )
                                                                parentDialog.removeAttribute(
                                                                    'inert'
                                                                )
                                                                parentDialog.style.pointerEvents =
                                                                    ''
                                                                parentDialog.style.userSelect =
                                                                    ''
                                                                parentDialog =
                                                                    null
                                                            }
                                                        }
                                                    )
                                                },
                                            }}
                                        />
                                        {isLocked && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    zIndex: 10,
                                                    cursor: 'not-allowed',
                                                }}
                                            />
                                        )}
                                    </Box>
                                </FormControl>
                                <FormControl fullWidth sx={{ mt: 2 }}>
                                    <FormInputLabel>
                                        {this.props.kedo.t('Pre text')}
                                    </FormInputLabel>

                                    <TextField
                                        size="small"
                                        multiline
                                        rows={3}
                                        disabled={isLocked}
                                        value={
                                            trans.settings &&
                                            trans.settings.pretext
                                                ? trans.settings.pretext
                                                : ''
                                        }
                                        onChange={(event) =>
                                            this.onChangeTranslationSettings(
                                                locale.code,
                                                event.target.value,
                                                'pretext'
                                            )
                                        }
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                    )
                })}
            </div>
        )
    }

    onChangeObjectField(fieldName, itemId) {
        let item = null
        if (fieldName === 'defDossierDefField') {
            item = this.state.dataFields.find(
                (dataItem) => String(dataItem.id) === String(itemId)
            )
        } else if (fieldName === 'defDossierLink') {
            item = this.state.linkFields.find(
                (dataItem) => String(dataItem.id) === String(itemId)
            )
        } else if (fieldName === 'displayPosition') {
            item = this.state.displayPositions.find(
                (dataItem) => String(dataItem.id) === String(itemId)
            )
        }

        if (!item) {
            return
        }

        let curItem = this.state.item
        curItem[fieldName] = item
        this.setState({ item: curItem })
    }

    getDataFieldOptions() {
        const kedo = this.props.kedo
        const options = []
        const includeType = (type) =>
            !this.props.type || this.props.type.includes(type)

        if (includeType('text')) {
            this.state.dataFields
                .filter((item) => this.isTextType(item))
                .forEach((item) => {
                    options.push({
                        id: item.id,
                        label: item.name,
                        group: kedo.t('Text'),
                    })
                })
        }

        if (includeType('date')) {
            this.state.dataFields
                .filter((item) => item.def_field?.type === 'date')
                .forEach((item) => {
                    options.push({
                        id: item.id,
                        label: item.name,
                        group: kedo.t('Date'),
                    })
                })
        }

        if (includeType('list')) {
            this.state.dataFields
                .filter((item) => item.def_field?.type === 'list')
                .forEach((item) => {
                    options.push({
                        id: item.id,
                        label: item.name,
                        group: kedo.t('List'),
                    })
                })
        }

        const includeOther =
            !this.props.type ||
            this.state.dataFields.filter((item) =>
                this.props.type.includes(item.type)
            ).length > 0

        if (includeOther) {
            this.state.dataFields
                .filter(
                    (item) =>
                        !this.isTextType(item) &&
                        item.type !== 'date' &&
                        item.type !== 'list' &&
                        item.type !== 'tree'
                )
                .forEach((item) => {
                    options.push({
                        id: item.id,
                        label: item.name,
                        group: kedo.t('Other'),
                    })
                })
        }

        return options
    }

    renderDisplayPositions() {
        const positions = this.state.displayPositions || []
        const selectedId =
            this.state.item.display_position_id ??
            this.state.item.displayPosition?.id
        const selected =
            positions.find((item) => String(item.id) === String(selectedId)) ||
            null
        const disabled =
            (this.props.item && this.props.item.display_position) ||
            this.state.submitting ||
            this.state.item?.locked === true

        return (
            <FormControl
                fullWidth
                disabled={disabled}
                error={Boolean(this.state.errors['displayPosition'])}
            >
                <FormInputLabel>
                    {this.props.kedo.t('Location')}{' '}
                    {this.state.fetchingPositions ? <LoadingDefault /> : null}
                </FormInputLabel>

                <Autocomplete
                    size="small"
                    autoHighlight
                    options={positions}
                    getOptionLabel={(option) => option.name_plural || ''}
                    isOptionEqualToValue={(option, value) =>
                        String(option.id) === String(value.id)
                    }
                    value={selected}
                    disabled={disabled}
                    onChange={(_event, option) => {
                        if (!option) {
                            return
                        }
                        this.onChangeObjectField('displayPosition', option.id)
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder={this.props.kedo.t('Choose an option')}
                            error={Boolean(
                                this.state.errors['displayPosition']
                            )}
                        />
                    )}
                />
                {this.renderErrorFeedback(this.state.errors['displayPosition'])}
            </FormControl>
        )
    }

    getViewOptions() {
        const kedo = this.props.kedo
        return [
            {
                value: 'show/edit',
                label: `${kedo.t('Show')}/${kedo.t('Edit')}`,
            },
            { value: 'edit', label: kedo.t('Edit') },
            { value: 'show', label: kedo.t('Show') },
            { value: 'list', label: kedo.t('List') },
            { value: 'search', label: kedo.t('Search') },
            {
                value: 'advanced-search',
                label: kedo.t('Advanced search'),
            },
            { value: 'summary', label: kedo.t('Summary') },
        ]
    }

    renderLinkFields() {
        if (this.isDataField() || (this.props.item && !this.isLinkField())) {
            return ''
        }

        return (
            <FormControl
                fullWidth
                disabled
                error={Boolean(this.state.errors['defDossierLink'])}
            >
                <FormInputLabel>
                    {this.props.kedo.t('Link field')}{' '}
                    {this.state.fetchingLinks ? <LoadingDefault /> : null}
                </FormInputLabel>

                <Autocomplete
                    size="small"
                    autoHighlight
                    options={this.state.linkFields || []}
                    getOptionLabel={(option) =>
                        typeof option === 'string' ? option : option?.name || ''
                    }
                    isOptionEqualToValue={(a, b) =>
                        String(a?.id) === String(b?.id)
                    }
                    value={
                        (this.state.linkFields || []).find(
                            (item) =>
                                String(item.id) ===
                                String(this.state.item.defDossierLink?.id)
                        ) || null
                    }
                    disabled
                    onChange={(_event, option) => {
                        if (!option) {
                            return
                        }
                        this.onChangeObjectField('defDossierLink', option.id)
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder={this.props.kedo.t('Choose an option')}
                            error={Boolean(this.state.errors['defDossierLink'])}
                        />
                    )}
                />
                {this.renderErrorFeedback(this.state.errors['defDossierLink'])}
            </FormControl>
        )
    }

    renderDataFields() {
        if (this.isLinkField() || (this.props.item && !this.isDataField())) {
            return ''
        }

        const options = this.getDataFieldOptions()
        const selectedId = this.state.item.defDossierDefField?.id
        const selected =
            options.find(
                (option) => String(option.id) === String(selectedId)
            ) || null

        return (
            <FormControl
                fullWidth
                disabled={
                    (this.props.item && this.props.item.defDossierDefField) ||
                    this.state.submitting ||
                    this.state.item?.locked === true
                }
                error={Boolean(this.state.errors['defDossierDefField'])}
            >
                <FormInputLabel>
                    {this.props.kedo.t('Data field')}{' '}
                    {this.state.fetchingFields ? <LoadingDefault /> : null}
                </FormInputLabel>

                <Autocomplete
                    size="small"
                    slotProps={autocompleteGroupedSlotProps}
                    options={this.getDisplayDataFieldOptions()}
                    groupBy={(option) => this.getDisplayDataFieldGroup(option)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                    }
                    value={
                        this.state.item.defDossierDefField?.id
                            ? this.state.dataFields.find(
                                  (item) =>
                                      item.id ===
                                      this.state.item.defDossierDefField.id
                              ) || null
                            : null
                    }
                    onChange={(_event, option) => {
                        if (option) {
                            this.onChangeObjectField(
                                'defDossierDefField',
                                option.id
                            )
                        }
                    }}
                    disabled={
                        (this.props.item &&
                            this.props.item.defDossierDefField) ||
                        this.state.submitting ||
                        this.state.item?.locked === true
                    }
                    loading={this.state.fetchingFields}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder={this.props.kedo.t('Choose an option')}
                            error={Boolean(
                                this.state.errors['defDossierDefField']
                            )}
                        />
                    )}
                />

                {this.renderErrorFeedback(
                    this.state.errors['defDossierDefField']
                )}
            </FormControl>
        )
    }

    getDisplayDataFieldGroup(item) {
        const kedo = this.props.kedo
        if (this.isTextType(item)) {
            return kedo.t('Text')
        }
        if (
            item.def_field?.type === 'date' ||
            item.def_field?.type === 'datetime'
        ) {
            return kedo.t('Date')
        }
        if (item.def_field?.type === 'list') {
            return kedo.t('List')
        }
        return kedo.t('Other')
    }

    getDisplayDataFieldOptions() {
        const fields = this.state.dataFields || []
        const typeFilter = this.props.type
        const includeText = !typeFilter || typeFilter.includes('text')
        const includeDate = !typeFilter || typeFilter.includes('date')
        const includeList = !typeFilter || typeFilter.includes('list')
        const includeOther =
            !typeFilter ||
            fields.filter((item) => typeFilter.includes(item.type)).length > 0

        const text = includeText
            ? fields.filter((item) => this.isTextType(item))
            : []
        const date = includeDate
            ? fields.filter(
                  (item) =>
                      item.def_field?.type === 'date' ||
                      item.def_field?.type === 'datetime'
              )
            : []
        const list = includeList
            ? fields.filter((item) => item.def_field?.type === 'list')
            : []
        const other = includeOther
            ? fields.filter(
                  (item) =>
                      !this.isTextType(item) &&
                      item.type !== 'date' &&
                      item.type !== 'datetime' &&
                      item.type !== 'list' &&
                      item.type !== 'tree'
              )
            : []

        return [...text, ...date, ...list, ...other]
    }

    isTextType(item) {
        if (!item.def_field) {
            return false
        }
        if (item.def_field.type === 'url' || item.def_field.type === 'email') {
            return true
        } else if (
            item.def_field.type === 'text' ||
            item.def_field.type === 'textarea'
        ) {
            return true
        }
    }

    hasSufficientTabData(tabName) {
        if (tabName === 'field') {
            if (
                this.state.item.defDossierDefField ||
                this.state.item.defDossierLink
            ) {
                return ''
            }
        }

        if (tabName === 'labels') {
            let missingTranslations = false

            this.props.kedo
                .env()
                .getEnvironmentLocales()
                .map((locale) => {
                    if (!this.state.item.translations) {
                        missingTranslations = true
                    } else if (
                        !this.state.item.translations.find(
                            (translation) => translation.culture === locale.code
                        )
                    ) {
                        missingTranslations = true
                    } else if (
                        !this.state.item.translations.find(
                            (translation) => translation.culture === locale.code
                        ).name
                    ) {
                        missingTranslations = true
                    } else if (
                        this.state.item.translations.find(
                            (translation) => translation.culture === locale.code
                        ).name.length <= 0
                    ) {
                        missingTranslations = true
                    }
                })
        }

        if (tabName === 'layout') {
            let missingLayout = false

            if (
                this.state.item &&
                this.state.item.col >= 0 &&
                this.state.item.colspan >= 0 &&
                this.state.item.rank >= 0
            ) {
                return ''
            } else {
                return (
                    <FontAwesomeIcon
                        className={`validationIcon validationFailed`}
                        icon={faExclamationCircle}
                    />
                )
            }
        }

        return null
    }

    onChangeRole(e) {
        let item = this.state.item
        item.roles = item.roles.filter((roleId) => e.target.value != roleId)

        if (e.target.checked) {
            item.roles.push(parseInt(e.target.value))
        }

        this.setState({ item: item })
    }

    onChangeSettings(name, value) {
        let item = this.state.item
        if (!item.settings) {
            item.settings = {}
        }
        item.settings[name] = value
        this.setState({ item: item })
    }

    renderViewSpecificSettings(displayItem) {
        if (
            displayItem.view === 'search' &&
            displayItem.def_dossier_def_field &&
            displayItem.def_dossier_def_field.def_field
        ) {
            const fieldType = displayItem.def_dossier_def_field.def_field.type
            const isLocked = this.state.item?.locked === true

            return (
                <div>
                    {(fieldType === 'amount' || fieldType === 'calc') && (
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <FormControlLabel
                                size="small"
                                control={
                                    <Checkbox
                                        checked={
                                            this.state.item?.settings
                                                ?.show_slider === true
                                        }
                                        onChange={(e) =>
                                            this.onChangeSettings(
                                                'show_slider',
                                                e.target.checked
                                            )
                                        }
                                        name="show_slider"
                                        id="radio-show-slider"
                                    />
                                }
                                label={this.props.kedo.t('Show slider')}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontWeight: 500,
                                        fontSize: '0.875rem',
                                        color: 'text.primary',
                                    },
                                }}
                                disabled={isLocked}
                            />
                        </FormControl>
                    )}

                    {(fieldType === 'amount' || fieldType === 'calc') && (
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <FormInputLabel>
                                {this.props.kedo.t('Max slider')}
                            </FormInputLabel>
                            <TextField
                                id="radio-max-slider"
                                name="max_slider"
                                size="small"
                                disabled={isLocked}
                                value={
                                    this.state.item?.settings?.max_slider ??
                                    1000
                                }
                                onChange={(e) =>
                                    this.onChangeSettings(
                                        'max_slider',
                                        e.target.value
                                    )
                                }
                            />
                        </FormControl>
                    )}
                </div>
            )
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'md'}
                topAlign={true}
                fullWidth
                disableEnforceFocus
                title={
                    <>
                        {this.props.id ||
                        (this.props.item && this.props.item.id)
                            ? kedo.t('Edit')
                            : kedo.t('Add')}{' '}
                        {kedo.t('Display field').toLowerCase()}
                        {this.props.id ? (
                            <Box
                                component="small"
                                sx={{ color: 'text.disabled' }}
                            >
                                {' '}
                                ({this.props.id})
                            </Box>
                        ) : null}
                    </>
                }
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true, dense: true }}
                actions={
                    <>
                        <StyledButton
                            disabled={
                                this.state.fetchingPositions ||
                                this.state.fetchingLinks ||
                                this.state.fetchingFields ||
                                this.state.item.locked
                            }
                            onClick={this.submitDisplayItem}
                            sx={{ '& svg': { mr: 1 } }}
                        >
                            {this.state.submitting ? (
                                <LoadingDefault />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            {this.props.kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <>
                    {this.state.errors['generic'] ? (
                        <Alert severity={'error'}>
                            {this.state.errors['generic']}
                        </Alert>
                    ) : this.state.item.locked ? (
                        <Alert severity={'info'}>
                            {this.props.kedo.t('edit_not_allowed')}
                        </Alert>
                    ) : null}
                    {this.state.loading ? (
                        <LoadingDefault />
                    ) : (
                        <Grid container>
                            <Grid
                                size={3}
                                sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                }}
                            >
                                <Tabs
                                    value={this.state.activeTab}
                                    orientation="vertical"
                                    onChange={(event, newValue) =>
                                        this.setState((prevState) => ({
                                            ...prevState,
                                            activeTab: newValue,
                                        }))
                                    }
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            display: 'none',
                                        },
                                        '& .MuiTab-root': {
                                            display: 'block',
                                            textAlign: 'left',
                                        },
                                    }}
                                >
                                    <StyledVerticalTab
                                        label={
                                            <>
                                                {this.hasSufficientTabData(
                                                    'labels'
                                                )}
                                                {kedo.t('Labels')}
                                            </>
                                        }
                                        value="labels"
                                    />
                                    <StyledVerticalTab
                                        label={
                                            <>
                                                {this.hasSufficientTabData(
                                                    'field'
                                                )}
                                                {kedo.t('Field')}
                                            </>
                                        }
                                        value="field"
                                    />
                                    <StyledVerticalTab
                                        label={
                                            <>
                                                {this.hasSufficientTabData(
                                                    'layout'
                                                )}
                                                {kedo.t('Layout')}
                                            </>
                                        }
                                        value="layout"
                                    />
                                    <StyledVerticalTab
                                        label={kedo.t('Permissions')}
                                        value="permissions"
                                    />
                                    <StyledVerticalTab
                                        label={this.props.kedo.t('Settings')}
                                        value="ddi-file-settings"
                                    />
                                    {this.state.item && this.state.item.id ? (
                                        <StyledVerticalTab
                                            label={kedo.t('Info')}
                                            value="info"
                                        />
                                    ) : null}
                                </Tabs>
                            </Grid>
                            <Grid size={9}>
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="labels"
                                >
                                    <h3>{kedo.t('Labels')}</h3>
                                    {this.renderTranslations(
                                        this.state.item.translations
                                    )}
                                </TabPanel>
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="field"
                                >
                                    <h3>{kedo.t('Field')}</h3>
                                    {this.renderDataFields()}
                                    {this.renderLinkFields()}
                                </TabPanel>
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="layout"
                                >
                                    <h3>{kedo.t('Layout')}</h3>
                                    {this.state.item &&
                                    (this.state.item.view === 'edit' ||
                                        this.state.item.view === 'show')
                                        ? this.renderDisplayPositions()
                                        : null}
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <FormInputLabel>
                                            {kedo.t('View')}
                                        </FormInputLabel>

                                        <Autocomplete
                                            size="small"
                                            autoHighlight
                                            options={this.getViewOptions()}
                                            getOptionLabel={(option) =>
                                                option.label || ''
                                            }
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) => option.value === value.value}
                                            value={
                                                this.getViewOptions().find(
                                                    (option) =>
                                                        option.value ===
                                                        this.state.item.view
                                                ) || null
                                            }
                                            onChange={(_event, option) =>
                                                this.handleChange({
                                                    target: {
                                                        name: 'view',
                                                        value: option
                                                            ? option.value
                                                            : '',
                                                    },
                                                })
                                            }
                                            disabled={
                                                this.state.item.locked ||
                                                this.state.submitting
                                            }
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    size="small"
                                                    error={
                                                        !!this.state.errors[
                                                            'view'
                                                        ]
                                                    }
                                                />
                                            )}
                                        />

                                        {this.renderErrorFeedback(
                                            this.state.errors['view']
                                        )}
                                    </FormControl>
                                    <hr />
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <FormInputLabel>
                                            {kedo.t('Rank')}
                                        </FormInputLabel>
                                        <TextField
                                            size="small"
                                            name="rank"
                                            type="number"
                                            value={this.state.item.rank}
                                            onChange={(e) =>
                                                this.handleChange(e)
                                            }
                                            InputProps={{
                                                readOnly:
                                                    this.state.submitting ===
                                                    true,
                                            }}
                                            error={!!this.state.errors['rank']}
                                            disabled={this.state.item.locked}
                                        />
                                        {this.renderErrorFeedback(
                                            this.state.errors['rank']
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <FormInputLabel>
                                            {kedo.t('Column order')}
                                        </FormInputLabel>
                                        <TextField
                                            size="small"
                                            name="col"
                                            type="number"
                                            value={this.state.item.col}
                                            onChange={(e) =>
                                                this.handleChange(e)
                                            }
                                            InputProps={{
                                                readOnly:
                                                    this.state.submitting ===
                                                    true,
                                            }}
                                            error={!!this.state.errors['col']}
                                            disabled={this.state.item.locked}
                                        />
                                        {this.renderErrorFeedback(
                                            this.state.errors['col']
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <FormInputLabel>
                                            {kedo.t('Width')}
                                        </FormInputLabel>
                                        <TextField
                                            size="small"
                                            name="colspan"
                                            type="number"
                                            value={this.state.item.colspan}
                                            onChange={(e) =>
                                                this.handleChange(e)
                                            }
                                            InputProps={{
                                                readOnly:
                                                    this.state.submitting ===
                                                    true,
                                            }}
                                            error={
                                                !!this.state.errors['colspan']
                                            }
                                            disabled={this.state.item.locked}
                                        />
                                        {this.renderErrorFeedback(
                                            this.state.errors['colspan']
                                        )}
                                    </FormControl>
                                </TabPanel>
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="permissions"
                                >
                                    <h3>{kedo.t('Permissions')}</h3>
                                    <FormControl
                                        component="fieldset"
                                        size="small"
                                        sx={{ mt: 2 }}
                                    >
                                        <FormInputLabel>
                                            {kedo.t('Roles')}
                                        </FormInputLabel>

                                        <FormGroup>
                                            {this.state.availableRoles.map(
                                                (item) => (
                                                    <FormControlLabel
                                                        key={item.id}
                                                        control={
                                                            <Checkbox
                                                                checked={
                                                                    this.state.item?.roles?.includes(
                                                                        item.id
                                                                    ) ?? false
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onChangeRole
                                                                }
                                                                id={`role-${item.id}`}
                                                                size="small"
                                                                value={item.id}
                                                                disabled={
                                                                    this.state
                                                                        .item
                                                                        .locked
                                                                }
                                                            />
                                                        }
                                                        label={item.name}
                                                        sx={{
                                                            mb: 0,
                                                            '& .MuiFormControlLabel-label':
                                                                {
                                                                    fontSize:
                                                                        '0.875rem',
                                                                    color: 'text.primary',
                                                                },
                                                        }}
                                                    />
                                                )
                                            )}
                                        </FormGroup>
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <FormInputLabel>
                                            {kedo.t('Permissions type')}
                                        </FormInputLabel>

                                        <Select
                                            size="small"
                                            name="permissions_type"
                                            value={
                                                this.state.item
                                                    .permissions_type ?? ''
                                            }
                                            onChange={this.handleChange}
                                            inputProps={{
                                                readOnly: this.state.submitting,
                                            }}
                                            displayEmpty
                                            disabled={this.state.item.locked}
                                        >
                                            <MenuItem value="">
                                                {kedo.t('Choose an option')}
                                            </MenuItem>
                                            <MenuItem value="EXCLUDE_SELECTED_ROLES">
                                                {kedo.t(
                                                    'EXCLUDE_SELECTED_ROLES'
                                                )}
                                            </MenuItem>
                                            <MenuItem value="INCLUDE_SELECTED_ROLES">
                                                {kedo.t(
                                                    'INCLUDE_SELECTED_ROLES'
                                                )}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormGroup sx={{ mt: 2 }}>
                                        <FormInputLabel sx={{ mb: 0 }}>
                                            {kedo.t('Condition query')}
                                        </FormInputLabel>
                                        <SelectList
                                            currentValue={
                                                this.state.item?.settings
                                                    ?.condition_query
                                            }
                                            disableInit={true}
                                            disabled={this.state.item.locked}
                                            onClear={() =>
                                                this.setState(
                                                    {
                                                        condition_query: null,
                                                    },
                                                    () =>
                                                        this.onChangeSettings(
                                                            'condition_query',
                                                            null
                                                        )
                                                )
                                            }
                                            searchName={'search'}
                                            kedo={this.props.kedo}
                                            urlParams={{
                                                defDossier:
                                                    this.state.defDossier,
                                            }}
                                            onDisplayName={(item) => {
                                                return (
                                                    item.id +
                                                    ': ' +
                                                    this.props.kedo
                                                        .env()
                                                        .translateItem(
                                                            item,
                                                            'dossierquery'
                                                        )
                                                )
                                            }}
                                            url={this.props.kedo
                                                .api()
                                                .getDossierQueryEndpoint()}
                                            onSelect={(item) => {
                                                this.setState(
                                                    {
                                                        condition_query:
                                                            item.id,
                                                    },
                                                    () =>
                                                        this.onChangeSettings(
                                                            'condition_query',
                                                            item.id
                                                        )
                                                )
                                            }}
                                        />
                                    </FormGroup>
                                </TabPanel>
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="ddi-file-settings"
                                >
                                    <DisplayItemSettings
                                        onChange={this.onChangeSettings}
                                        item={this.state.item}
                                        kedo={this.props.kedo}
                                        disabled={this.state.item?.locked}
                                    />
                                    {this.renderViewSpecificSettings(
                                        this.state.item
                                    )}
                                </TabPanel>
                                {this.state.item && this.state.item.id ? (
                                    <TabPanel
                                        value={this.state.activeTab}
                                        index="info"
                                    >
                                        <h3>{kedo.t('Info')}</h3>
                                        <ObjectCreatedInfo
                                            kedo={kedo}
                                            item={this.state.item}
                                        />
                                    </TabPanel>
                                ) : null}
                            </Grid>
                        </Grid>
                    )}
                </>
            </AppDialog>
        )
    }
}

export default DisplayItemForm
